import { Component } from '@angular/core';
import { ModalRef } from '@core-lib/modules/modal-container';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-token-expired-modal',
    templateUrl: './token-expired-modal.component.html',
    styleUrls: [],
    standalone: false
})
export class TokenExpiredModalComponent {
  public onClose: Subject<void> = new Subject();

  constructor(public modalRef: ModalRef) { }

  onOk() {
    this.onClose.next();
    this.modalRef.hide();
  }
}
